import type { ReactNode } from 'react';

import { MAIL_CONTENT_KINDS, TEMPLATE_TYPES } from 'cpool-constants';
import type { SchemaUserResolver_Get } from 'cpool-tables/backend-resolvers';
import DOMPurify from 'dompurify';

import { useOwnMailHeaderFooter } from './hooks/useOwnMailHeaderFooter';
import { formatEtaHeaderFooterSignatureContent } from './utils/formatEtaHeaderFooterSignatureContent';
import type { InputKind } from '../headerFooterTemplate/types';

type Props = {
    contentKind: InputKind;
    user: SchemaUserResolver_Get | undefined;
};

export const Header: React.FC<Props> = ({ contentKind, user }) => {
    const { data } = useOwnMailHeaderFooter();
    const header = data?.header ?? null;

    const convertedHeaderContent: string | Array<ReactNode> = formatEtaHeaderFooterSignatureContent({
        contentKind,
        mailContent: header && { data: header, type: TEMPLATE_TYPES.MAIL_HEADER },
        user,
    });

    if (contentKind === MAIL_CONTENT_KINDS.MAIL_CONTENT && convertedHeaderContent) {
        return <div>{convertedHeaderContent}</div>;
    }
    if (contentKind === MAIL_CONTENT_KINDS.MAIL_HTML_CONTENT && convertedHeaderContent) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(convertedHeaderContent as string, {
                        ADD_TAGS: ['style'],
                    }),
                }}
            />
        );
    }
    return null;
};
